import React from 'react';

import navigateToURL from 'lib/navigateToURL';
import {BenchlingAppSummary} from 'schemas/SchemaConstants';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

interface RelatedBenchlingAppsArchiveWarningProps {
  itemName: string;
  itemType: string;
  relatedBenchlingApps: Array<BenchlingAppSummary>;
}

export default function RelatedBenchlingAppsArchiveWarning(
  props: RelatedBenchlingAppsArchiveWarningProps
): JSX.Element {
  return (
    <>
      <InlineBanner
        bannerType={InlineBannerType.WARNING}
        text={`${props.itemName} is referenced by active app configs`}
        supportingInfo={`Archiving this ${props.itemType} may cause those apps to fail.`}
      />
      <p className="u-small-spacing-top">
        The following app configurations reference <strong>{props.itemName}</strong>:
      </p>
      <ul>
        {props.relatedBenchlingApps.map((appSummary, i) => (
          <li key={i}>
            <a
              onClick={() => {
                navigateToURL(appSummary.url);
              }}
            >
              {appSummary.name}
            </a>
          </li>
        ))}
      </ul>
    </>
  );
}
